import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import CategoriaPessoaService from "./categoriaPessoaService"
import FormList from 'base/FormList'

export default function CategoriaPessoaList() {

    const [service] = useState(() => new CategoriaPessoaService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_catp',
        dsName: 'descricao_catp',
        mainField: { name: 'descricao_catp', label: 'Descrição' },
        advFields: [
            { name: 'codigo_catp', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_catp', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_catp" sortable header="Descrição"></Column>
            <Column field="meta.descricao_tipe" sortable header="Tipo"></Column>
        </FormList >
    )
}
